<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" style="padding: 10px 30px 30px">
      <h3 style="padding-right: 5px;"><b style="color: grey;">Contenitore: </b>{{data.resource.name }} </h3>
      <h3 *ngIf="data.resource.address" style="padding-right: 5px;"><b style="color: grey;">Indirizzo: </b>{{data.resource.address}} </h3>
      <h3 *ngIf="data.resource.type_item?.type" style="padding-right: 5px;"><b style="color: grey;">Tipologia: </b>{{data.resource.type_item?.type}} </h3>
      <h3 *ngIf="data.resource.type_item?.waste_type" style="padding-right: 5px;">{{data.resource.type_item?.waste_type}} </h3>
      <h3 *ngIf="data.resource.type_item?.capacity" style="padding-right: 5px;">{{data.resource.type_item?.capacity}}</h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)"-->
      <table mat-table [dataSource]="data!.data"  aria-describedby="tags tables" matSort>
        <ng-container matColumnDef="idcli">
          <th mat-header-cell *matHeaderCellDef >
            {{ "tag.grid.column.idcli" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.idcli }}</td>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>
            {{ "tag.grid.column.code" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.code }}</td>
        </ng-container>
        <ng-container matColumnDef="tagtype">
          <th mat-header-cell *matHeaderCellDef >
            {{ "tag.grid.column.tagtype" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.tagtype_item?.type }}
          </td>
        </ng-container>
        
        <ng-container matColumnDef="group">
          <th mat-header-cell *matHeaderCellDef>
            {{ "tag.grid.column.group" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.group_item?.name }}</td>
        </ng-container>

  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
            
          </td>
        </tr>
      </table>
    </div>
</div>
  